import { AxiosClient } from '@/app/shared/services';

const state = {
    outgoingPhonesList: {
        list: [],
        isLoading: false,
    },
};

const getters = {
    OUTGOING_PHONES_LOADING: (state) => state.outgoingPhonesList.isLoading,
    OUTGOING_PHONES_LIST: (state) => state.outgoingPhonesList.list,
};

const mutations = {
    SET_OUTGOING_PHONES_LIST: (state, account_mailers) => {
        state.outgoingPhonesList.list = account_mailers;
    },
    SET_OUTGOING_PHONES_LOADING: (state, isLoading) => {
        state.outgoingPhonesList.isLoading = isLoading;
    },
};

const actions = {
    GET_OUTGOING_PHONES_LIST: (context, params) => {
        context.commit('SET_OUTGOING_PHONES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/call/get_outgoing_phones', {params})
                .then((response) => {
                    context.commit('SET_OUTGOING_PHONES_LIST', response.data);
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_OUTGOING_PHONES_LOADING', false);
                });
        });
    },
    UPDATE_OUTGOING_PHONES: (context) => {
        context.commit('SET_OUTGOING_PHONES_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/call/update_outgoing_phones')
                .then((response) => {
                    resolve(response);
                })
                .catch(() => reject())
                .finally(() => {
                    context.commit('SET_OUTGOING_PHONES_LOADING', false);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
